import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Img from 'gatsby-image';
import { compose } from 'redux';
import styled, { withTheme } from 'styled-components';

/**
 * Landing page
 */
import Log from '../../utilities/log';
import Announcement from './announcement';
import BookButton from './book-button';
import Characters from './characters';
import Devices from './devices';
import Faq from './faq';
import Footer from './footer';
import Goods from './goods';
import HowToPlay from './how-to-play';
import Information from './information';
import jaLocale from './ja.locale';
import KeyVisual from './key-visual';
import News from './news';
import Participate from './participate';
import Reword from './reword';
import SocialButtons from './social-buttons';
import Tips from './tips';
import Warning from './warning';
import World from './world';

/**
 * Container
 */
const Container = styled.div`
  color: white;
  width: 100%;
`;

const Background = styled(Img)`
  position: fixed !important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  z-index: -1;

  & > div:first-child {
    padding-bottom: ${({ fluid }) => 100 / fluid[0].aspectRatio}% !important;

    @media (min-width: 768px) {
      padding-bottom: ${({ fluid }) => 100 / fluid[1].aspectRatio}% !important;
    }
  }
`;
const TwinColumnedDesktop = styled.div`
  max-width: 50em;
  padding: 4em 1em;
  margin: 0 auto;
  > *:not(:last-child) {
    margin-bottom: 5em;
  }

  @media (min-width: 768px) {
    display: flex;
    > * {
      flex: 1;
    }
    > *:not(:last-child) {
      margin-right: 2em;
    }
  }
`;

const nImages = 1;

const logs = new Log('CmpLandingPage');
class CmpLandingPage extends PureComponent {
  state = {
    loading: true,
    nLoadedImages: 0,
    shareUrl: ''
  };
  constructor(props) {
    super(props);
    logs.alog('jaLocale', jaLocale);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }
  componentDidMount() {
    this.setState({
      shareUrl: window.location.href
    });
  }

  handleLoaded = () => {
    this.setState(({ loading, nLoadedImages }) => {
      nLoadedImages += 1;
      if (nLoadedImages >= nImages) {
        loading = false;
      }
      return {
        loading,
        nLoadedImages
      };
    });
  };

  render() {
    const { gameId, data } = this.props;
    const { loading } = this.state;

    const sources = [
      data.backgroundImageM.childImageSharp.fluid,
      {
        ...data.backgroundImage.childImageSharp.fluid,
        media: `(min-width: 768px)`
      }
    ];

    return (
      <Container>
        {/* -------------------------------------------------------------- */}
        {/* common content                                                 */}
        {/* -------------------------------------------------------------- */}

        {/* 予約ボタン */}
        {!loading && <BookButton gameId={gameId} />}

        {/* Twitter, Facebook, Line */}
        <Translate>
          {({ translate }) => (
            <SocialButtons
              iconStyles={{
                fill: '#111111',
                stroke: this.props.theme.primary,
                strokeWidth: '3'
              }}
              shareTitle={translate(`landingPage.games.${gameId}.title`)}
              shareUrl={this.state.shareUrl}
            />
          )}
        </Translate>

        {/* 背景 */}
        <Background fluid={sources} onLoad={this.handleLoaded} />

        {/* -------------------------------------------------------------- */}
        {/* main content                                                   */}
        {/* -------------------------------------------------------------- */}

        <Announcement />
        <KeyVisual data={data} onLoad={this.handleLoaded} />
        <Characters data={data} onLoad={this.handleLoaded} />
        <HowToPlay />
        <Tips />
        <World />
        <Reword />
        <Participate gameId={gameId} />
        <Information gameId={gameId} />
        <Devices gameId={gameId} />
        <TwinColumnedDesktop>
          <News />
          <Faq gameId={gameId} />
        </TwinColumnedDesktop>
        <Warning />
        <Goods />
        <Footer />
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global }) => ({
  gameId: global.gameId
});

export default compose(
  withTheme,
  withLocalize,
  connect(mapStateToProps, null)
)(CmpLandingPage);
